import { render, staticRenderFns } from "./gameAssets.vue?vue&type=template&id=4476d8ae&scoped=true"
import script from "./gameAssets.vue?vue&type=script&lang=js"
export * from "./gameAssets.vue?vue&type=script&lang=js"
import style0 from "./gameAssets.vue?vue&type=style&index=0&id=4476d8ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476d8ae",
  null
  
)

export default component.exports